import { render, staticRenderFns } from "./admin-razorpay.vue?vue&type=template&id=23108243"
import script from "./admin-razorpay.vue?vue&type=script&lang=js"
export * from "./admin-razorpay.vue?vue&type=script&lang=js"
import style0 from "./admin-razorpay.vue?vue&type=style&index=0&id=23108243&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports